export const isDirectLinkPage = (pathname: string) => {
  const regex = /^\/order\/(\[?[a-zA-Z0-9\-]+\]?)\/send-receipt$/;
  return regex.test(pathname);
};
